import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import rrulePlugin from '@fullcalendar/rrule';
import { OptionsInput } from '@fullcalendar/core';

import '@fullcalendar/core/main.css';
import '@fullcalendar/list/main.css';
import '@fullcalendar/timegrid/main.css';

const hourToScroll = new Date().getHours() - 2;

const calendarOptions: OptionsInput = {
  plugins: [rrulePlugin, timeGridPlugin, listPlugin, interactionPlugin],
  allDaySlot: false,
  slotEventOverlap: false,
  nowIndicator: true,
  firstDay: 1,
  scrollTime: `${hourToScroll > 0 ? hourToScroll : 0}:00:00`,
  columnHeaderFormat: {
    weekday: 'short',
    day: 'numeric',
  },
  titleFormat: {
    year: 'numeric',
    month: 'long',
  },
  eventTimeFormat: {
    meridiem: false,
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  },
  slotLabelFormat: {
    week: 'narrow',
    hour: 'numeric',
    hourCycle: 'h23',
    minute: '2-digit',
    meridiem: false,
  },
  header: {
    left: 'title',
    center: '',
    right: 'listWeek,timeGridWeek  prev,today,next',
  },
  buttonText: {
    list: 'Show in list',
    today: 'Today',
    timeGridWeek: 'Show in calendar',
  },
  buttonIcons: {
    prev: '',
    next: '',
  },
  listDayFormat: {
    weekday: 'long',
  },
  listDayAltFormat: {
    day: 'numeric',
  },
};

export default calendarOptions;
